export default __webpack_public_path__ + "static/media/farm-painting.f5ac04fb.png";